// removed by extract-text-webpack-plugin
module.exports = {"component":"WzZYMcqC7GhC4UdCRfhz-","message":"_2YOg_5iiMn4KnYXrcaCxdu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logout/Logout.css
// module id = 1516
// module chunks = 0